import { defineNuxtRouteMiddleware, navigateTo } from '#imports'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

import { HOME } from '~/scopes/home/route-names'

// As per nuxt documentation we should not return anything or return undefined if we do not want to alter the redirection.
// https://nuxt.com/docs/guide/directory-structure/middleware
// eslint-disable-next-line consistent-return
export default defineNuxtRouteMiddleware(async () => {
  const experiments = useExperiments()
  const isBouyguesActivated =
    experiments['experiment.servicesMobilePlanBouygues'] === 'withBouygues'

  if (!isBouyguesActivated) {
    return navigateTo({ name: HOME })
  }
})
